/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Tracking_Totalcount2Inputs */

const en_coinvestments_tracking_totalcount2 = /** @type {(inputs: Coinvestments_Tracking_Totalcount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Count`)
};

/**
* | output |
* | --- |
* | "Total Count" |
*
* @param {Coinvestments_Tracking_Totalcount2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_tracking_totalcount2 = /** @type {((inputs?: Coinvestments_Tracking_Totalcount2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Tracking_Totalcount2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_tracking_totalcount2(inputs)
});
export { coinvestments_tracking_totalcount2 as "coInvestments_tracking_totalCount" }